export const AdminDropdown = [
  // {
  //   label: "Application Permissions",
  //   text: "Application Permissions",
  //   value: "applicationpermission",
  //   selected: false,
  // },
  {
    label: "Roles",
    text: "Roles",
    value: "roles",
    selected: false,
  },
  {
    label: "User Management",
    text: "User Management",
    value: "usermanagement",
    selected: false,
  },
  // {
  //   label: "Manage Account",
  //   text: "Manage Account",
  //   value: "manageaccount",
  //   selected: false,
  // },
  // {
  //   label: "App Onboarding",
  //   text: "App Onboarding",
  //   value: "apponboarding",
  //   selected: false,
  // },
];

export const appRolesDropdown = [
  {
    label: "Application Permissions",
    value: "applicationpermission",
  },
  {
    label: "Roles",
    value: "roles",
  },
  {
    label: "User Management",
    value: "usermanagement",
  },
  {
    label: "Manage Account",
    value: "manageaccount",
  },
  {
    label: "App Onboarding",
    value: "apponboarding",
  },
];

export const headerTiles = [
  {
    text: "Company",
    icontype: "submitted ",
    active: "active",
  },
  {
    text: "Active Users",
    icontype: "totalOrder ",
  },
];

export const editOption = {
  title: "View",
  value: "edit",
};

export const addOption = {
  title: "Add",
  value: "add",
};

export const deleteOption = {
  title: "Delete",
  value: "delete",
};

export const viewOption = {
  title: "View",
  value: "view",
};

export const appOnboardingInitialForm = {
  appName: "",
  tooltipdesc: "",
  isActive: false,
  category: "",
  tags: "",
  appUrl: "",
  logoBlobUrl: "",
  files: [],
  fileName: ""
};
export const appOnboardingInitialFormError = {
  appNameError: "",
  tooltipdescError: "",
  categoryError: "",
  logoImageFormatError: "",
  logoImageSizeError: "",
  logoImageError: ""
};

export const appAreaIntialForm = {
  application: "",
  areaName: "",
  areaId: "",
  isActive: false,
};
export const appAreaErrorForm = {
  applicationError: "",
  areaNameError: "",
  areaIdError: ""
};

export const addAppInitialForm = {
  roleId: 0,
  roleName: '',
  roleDescription: '',
  applications: [],
  permissions: [],
};

export const addAppInitialFormError = {
  roleNameError: '',
  roleDescriptionError: '',
  applicationsError: "",
};

export const multiSelectOptions = [
  { key: "1", text: "First Option" },
  { key: "2", text: "Second Option" },
  { key: "3", text: "Third Option" },
];
